import IconCalendar from '@/components/icons/IconCalendar.vue'
import IconUser from '@/components/icons/IconUser.vue'
import IconGender from '@/components/icons/IconGender.vue'
import IconMailSolid from '@/components/icons/IconMailSolid.vue'
import IconPhone from '@/components/icons/IconPhone.vue'
import IconPluse from '@/components/icons/IconPluse.vue'
import IconCross from '@/components/icons/IconCross.vue'
import IconFood from '@/components/icons/IconFood.vue'
import IconCheck from '@/components/icons/IconCheck.vue'
import IconQr from '@/components/icons/IconQr.vue'
import IconCure from '@/components/icons/IconCure.vue'
import IconMorning from "@/components/icons/IconMorning.vue"
import IconDay from "@/components/icons/IconDay.vue"
import IconEvening from "@/components/icons/IconEvening.vue"
import IconClock from "@/components/icons/IconClock.vue"
import IconCarRight from "@/components/icons/IconCarRight.vue"
import IconCarLeft from "@/components/icons/IconCarLeft.vue"
import IconOutlineMinus from "@/components/icons/IconOutlineMinus.vue"
import IconOutlinePlus from "@/components/icons/IconOutlinePlus.vue"

export default {
  calendar: IconCalendar,
  user: IconUser,
  gender: IconGender,
  mailSolid: IconMailSolid,
  phone: IconPhone,
  pluse: IconPluse,
  cross: IconCross,
  food: IconFood,
  check: IconCheck,
  qr: IconQr,
  cure: IconCure,
  morning: IconMorning,
  day: IconDay,
  evening: IconEvening,
  clock: IconClock,
  carRight: IconCarRight,
  carLeft: IconCarLeft,
  outlineMinus: IconOutlineMinus,
  outlinePlus: IconOutlinePlus,
}
